import { CognitoUserInterface } from '@aws-amplify/ui-components'
import { get } from 'lodash'

import { AdminPermission, permissions } from './types'

export const groups = {
  admin: permissions,
  owner: permissions,
  user: [],
}

export const roleInfo = {
  admin: {
    name: 'Admin',
  },
  user: {
    name: 'User',
  },
}

export const getGroups = (user): string => {
  const userGroups = user.payload['cognito:groups']
  return userGroups.reduce((acc, groupName) => {
    return `${acc}${acc ? ', ' : ''}${roleInfo[groupName] || ''}`
  })
}

export const hasPermission = (user: CognitoUserInterface, permissions: AdminPermission[]) => {
  const idTokenPayload = get(user, 'signInUserSession.idToken.payload', {})
  const userGroups = idTokenPayload['cognito:groups'] || ['user']

  const userPermissions = userGroups.reduce((acc, groupName) => {
    const groupPermissions = groups[groupName] || []
    return acc.concat(groupPermissions)
  }, [])

  return permissions.every((p) => userPermissions.includes(p))
}
